function createClientTraceId(): string {
    const c = typeof crypto !== 'undefined' ? crypto : undefined;
    if (c && typeof (c as Crypto & { randomUUID?: () => string }).randomUUID === 'function') {
        return (c as Crypto & { randomUUID: () => string }).randomUUID();
    }
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 11)}`;
}

const clientTraceId = createClientTraceId();

export function getClientTraceId(): string {
    return clientTraceId;
}
